import { render, staticRenderFns } from "./CartProduct.vue?vue&type=template&id=10525680&scoped=true&"
import script from "./CartProduct.vue?vue&type=script&lang=js&"
export * from "./CartProduct.vue?vue&type=script&lang=js&"
import style0 from "./CartProduct.vue?vue&type=style&index=0&id=10525680&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10525680",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/buddy/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VContainer,VFlex,VIcon,VImg,VLayout})
